export const ADD_ALERT_NOTE = 'ADD_ALERT_NOTE';
export const ADD_ALERT_NOTE_SUCCESS = 'ADD_ALERT_NOTE_SUCCESS';
export const ADD_ALERT_NOTE_FAIL = 'ADD_ALERT_NOTE_FAIL';

export const FETCH_ALERT_NOTE_HISTORY = 'FETCH_ALERT_NOTE_HISTORY';
export const FETCH_ALERT_NOTE_HISTORY_SUCCESS =
  'FETCH_ALERT_NOTE_HISTORY_SUCCESS';
export const FETCH_ALERT_NOTE_HISTORY_FAIL = 'FETCH_ALERT_NOTE_HISTORY_FAIL';

export const RESET_ALERT_NOTE = 'RESET_ALERT_NOTE';

export const addAlertNote = ({ alertId, alertNote }) => ({
  type: ADD_ALERT_NOTE,
  payload: { alertId, alertNote }
});

export const addAlertNoteSuccess = () => ({
  type: ADD_ALERT_NOTE_SUCCESS
});

export const addAlertNoteFail = () => ({
  type: ADD_ALERT_NOTE_FAIL
});

export const fetchAlertNoteHistory = ({ alertId }) => ({
  type: FETCH_ALERT_NOTE_HISTORY,
  payload: { alertId }
});

export const fetchAlertNoteHistorySuccess = ({ list, total }) => ({
  type: FETCH_ALERT_NOTE_HISTORY_SUCCESS,
  payload: { list, total }
});

export const fetchAlertNoteHistoryFail = () => ({
  type: FETCH_ALERT_NOTE_HISTORY_FAIL
});

export const resetAlertNote = () => ({
  type: RESET_ALERT_NOTE
});
